export default function StatCard({ label, value, sublabel, icon: Icon, accent = "text-nhp-primary", testId }) {
  return (
    <div
      data-testid={testId}
      className="border border-nhp-border bg-nhp-surface p-4 md:p-5 relative overflow-hidden"
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-nhp-muted truncate">
            {label}
          </div>
          <div className={`font-mono font-bold tabular-nums text-xl md:text-3xl mt-2 md:mt-3 truncate ${accent}`}>
            {value}
          </div>
          {sublabel && (
            <div className="text-xs text-nhp-muted mt-1 truncate">{sublabel}</div>
          )}
        </div>
        {Icon && (
          <div className="h-8 w-8 md:h-9 md:w-9 grid place-items-center border border-nhp-border bg-nhp-bg shrink-0">
            <Icon className={`h-4 w-4 ${accent}`} strokeWidth={1.75} />
          </div>
        )}
      </div>
    </div>
  );
}
